<p class="cmdk-coach__tips" aria-hidden="true">
  <span class="cmdk-coach__lead">{{ lead() }}</span>

  <span class="cmdk-coach__tip">
    <paper-kbd keys="?" size="sm" />
    <span>{{ shortcuts() }}</span>
  </span>

  <span class="cmdk-coach__sep">·</span>

  <span class="cmdk-coach__tip">
    <paper-kbd keys="" [mod]="true" size="sm" />
    <span>{{ quickOpen() }}</span>
  </span>

  <span class="cmdk-coach__sep">·</span>

  <span class="cmdk-coach__tip">
    <paper-kbd keys="⇧↵" size="sm" />
    <span>{{ book() }}</span>
  </span>
</p>

<paper-button
  intent="ghost"
  size="sm"
  data-testid="cmdk-coach-dismiss"
  (click)="dismiss()">
  {{ dismissLabel() }}
</paper-button>
